import turfLength from "@turf/length";
import turfCentroid from "@turf/centroid";
import turfPolygonToLine from "@turf/polygon-to-line";

export const calculateResult = (polygon) => {
  if (!polygon) return null;

  const line = turfPolygonToLine(polygon);
  const perimeter = turfLength(line, { units: "meters" });
  const centroid = turfCentroid(polygon);
  const [longitude, latitude] = centroid.geometry.coordinates;

  return { area: perimeter, latitude, longitude };
};

const RISK_ORDER = { low: 0, elevated: 1, high: 2 };

export const RISK_MESSAGE = {
  low: {
    text: "Risk parameters are evolving constantly, we therefore recommend reaching out to our team for an early risk assessment.",
    color: "#34BF90",
  },
  elevated: {
    text: "We advise obtaining a detailed risk analysis with an expert of our team.",
    color: "#f08902",
  },
  high: {
    text: "We strongly encourage a detailed risk analysis with an expert of our team.",
    color: "#E33022",
  },
};

export function computeMaxAssetRiskFrom(draw) {
  try {
    const feats = draw?.getAll()?.features || [];

    if (!feats.length) return null;

    const risks = feats
      .filter(f =>
        (f?.properties?.assetContour || f?.properties?.isBuilding) &&
        (f?.geometry?.type === 'Polygon' || f?.geometry?.type === 'MultiPolygon')
      )
      .map(f => String(f.properties?.riskClass || '').toLowerCase())
      .filter(r => r === 'low' || r === 'elevated' || r === 'high');

    if (!risks.length) return null;

    let max = 'low';
    for (const r of risks) {
      if (RISK_ORDER[r] >= RISK_ORDER[max]) max = r;
    }
    return { level: max, riskMessage: RISK_MESSAGE[max] };
  } catch {
    return null;
  }
}